module.exports = __webpack_public_path__ + "img/waves2.a3f4e24f.png";